import { render, staticRenderFns } from "./DpaAccountViewLogs.vue?vue&type=template&id=7d96cccc&"
import script from "./DpaAccountViewLogs.vue?vue&type=script&lang=js&"
export * from "./DpaAccountViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports